<template>
    <div class="flex results-11">
        
        <el-autocomplete
            :placeholder="isMobile ? 'Search...' : placeholder"
            prefix-icon="el-icon-search"
            class="ml-1 w-full"
            :debounce="700"
            v-model="search" 
            :fetch-suggestions="loadData"
            :trigger-on-focus="false"
            @select="handleClick"
            :popper-class="isMobile ? 'results-wrap-mobile' : 'results-wrap'"
            ref="search-input"
            @focus="focus"
        >     
            <template slot-scope="{item}">
                <div class="flex flex-col py-2" v-if="item.name!='view all' && item.link!='no-results' && item.link!='too-many-words'">
                    <div class="flex w-full">
                        <span>
                            <i class="uil mr-2" v-bind:class="{ 
                                'uil-truck text-green-400': item.isVehicle, 
                                'uil-user text-blue-400': !item.isVehicle && !item.isDevice,
                                'uil-mobile-android text-purple-400': item.isDevice 
                            }"></i>
                            {{  item.name }} 
                        </span>
                        <span 
                            class="ml-auto font-bold rounded-full bg-opacity-10 px-3 text-xs"
                            :class="setClassStatus(item.status)"    
                        >
                            {{ item.status }}
                        </span>
                    </div>
                    <small v-if="!item.isVehicle && !item.isDevice && item.record && item.record.overrideDisplayName" class="text-xs text-gray-500 pl-8">
                        Full Name: {{ item.record.firstName }} <template v-if="item.record.nickname">"{{ item.record.nickname }}" </template>{{ item.record.lastName }}
                    </small>
                    <small class="matching-fields pl-8" 
                    v-if="item.isVehicle || item.isDevice || item.record?.overrideDisplayName"
                    v-for="field, i in item.fields" :key="i"
                    >
                        {{ field }}: {{ item.record[mapField[field]] }}
                    </small>
                </div>
                <div v-else-if="item.link=='too-many-words'" class="w-full no-results leading-5 py-4 whitespace-normal">
                    {{item.name}}
                </div>
                <div v-else-if="item.link!=='no-results'" id="view-all-results" class="py-2 text-blue-600">
                    <i class="el-icon-search mr-2"></i>
                    View All {{ totalResults }} results

                </div>
                <div v-else-if="item.link=='no-results'" class="w-full no-results leading-5 pt-4 whitespace-normal">
                    {{item.name}}
                </div>
                <div v-else-if="item.name=='View Associates'" class="w-full">
                    <i class="uil mr-2 uil-user text-blue-400"></i>
                    {{ item.name }}
                </div>
                <div v-else-if="item.name=='View Vehicles'" class="w-full">
                    <i class="uil mr-2 uil-truck text-green-400"></i>
                    {{ item.name }}
                </div>
                <div v-else-if="item.name=='View Device List'" class="w-full">
                    <i class="uil mr-2 uil-mobile-android text-purple-400"></i>
                    {{ item.name }}
                </div>
            </template>
            <template v-slot:suffix>
                <i v-if="search" @click="close" class="el-icon-close"></i>
            </template>
        </el-autocomplete>
    </div>
</template>

<script>
import { API } from 'aws-amplify'
import { mapGetters, mapState } from "vuex";

export default {
    props: {
        user: {
            type: Object,
            default: null,
            required: false
        },
        query: {
            type: Object,
            default: () => { 
                return { 
                    "Staff": ['id', 'firstName', 'lastName', 'transporterId'],
                    "Vehicle": ['id', 'name'],
                    "Device": ['id', 'deviceName', 'phoneNumber', 'imei'] 
                }
            }
        },
        isMobile: {
            type:Boolean,
            default: false,
            required: false
        }
    },
    
    data(){
        return{
            search: '',
            placeholder: '',
            totalResults: 0,
            fieldMap: { "id": "ID", "firstName": "First Name", "lastName": "Last Name", "displayName": "Display Name", "nickname": "Nickname", "status": "Status", "transporterId": "Transporter ID", "email": "Email", "name": "Name", "vin": "VIN", "licensePlate": "License Plate", "phone": "Phone", "phoneNumber": "Phone", "deviceName": "Name", "imei": "IMEI" },
            mapField: { "ID":"id", "First Name": "firstName", "Last Name":"lastName", "Display Name": "displayName", "Nickname": "nickname", "Status": "status", "Transporter ID":"transporterId", "Email": "email", "Name": "name", "VIN": "vin", "License Plate": "licensePlate", "Phone": "phone", "IMEI": "imei" },
            searchTypes: ["Vehicle", "Staff", "Device"]
        }
    },

    computed:{
    ...mapGetters([
      'hasDAManagement',
      'hasVehicleManagementPermission',
      'hasWirelessSupportSyncPermission',
      'hasCompanyDevicesPermission',
      'tenantFeaturePermissions'
    ]),
    ...mapState([
      'valuelists',
    ]),
    statusFilterAssociate() {
        const indexAssociateStatus = this.staffStatuses.findIndex(s => s.value === 'Active')
        return {
            index: indexAssociateStatus
        }
    },
    statusFilterVehicle() {
        const indexVehicleStatus = this.vehicleStatuses.findIndex(s => s.value === 'Active')
        return {
            index: indexVehicleStatus
        }
    },
    staffStatuses(){
        return this.valueListActivesOnly(this.valuelists['staff-status']?.items||[])
    },
    vehicleStatuses(){
        return this.valueListActivesOnly(this.valuelists['vehicle-status']?.items||[])
    },
    routeQuery () {
        const query = {
            statusVehicle: this.statusFilterVehicle.index,
            statusAssociate: this.statusFilterAssociate.index,
            preferredDaysOff: -1,
            hourlyStatus: -1,
            labels: -1,
            company: -1,
            vehicleType: -1
        };
        return query;
    },
    noResults() {
        const baseResults = [
            { 
                name: 'No matching Associates or Vehicles could be found.', 
                link: 'no-results', 
                type: null 
            }
        ];
        if (this.hasDAManagement) {
            baseResults.push({
                name: 'View Associate List', link: {path: '/da-management/associate-list/',
                    query: {
                        status: this.routeQuery?.statusVehicle,
                        preferredDaysOff: this.routeQuery?.preferredDaysOff,
                        hourlyStatus: this.routeQuery?.hourlyStatus,
                        labels: this.routeQuery?.labels
                    }
                },
                isVehicle: false
            });
        }
        if (this.hasVehicleManagementPermission) {
            baseResults.push({
                name: 'View Vehicle List', link: {path: '/vehicles/vehicle-list/',
                query: {
                        labels: this.routeQuery?.labels,
                        company: this.routeQuery?.company,
                        vehicleType: this.routeQuery?.vehicleType,
                        status: this.routeQuery?.statusAssociate
                    }
                },
                isVehicle: true
            });
        }
        let deviceLink = '/devices';
        const permissionWirelessSupportSync = this.tenantFeaturePermissions["permissionWirelessSupportSync"];
        const hasCompanyDevicesPermission = this.hasCompanyDevicesPermission;
        if (permissionWirelessSupportSync === true && hasCompanyDevicesPermission) {
            deviceLink = this.goToAthena('/device/list');
        }
        baseResults.push({
                name: 'View Device List', 
                link: deviceLink, 
                isDevice: true
            });
        if (baseResults.length === 2) {
                baseResults[0].name = `No matching ${this.hasDAManagement ? 'Associates' : this.hasVehicleManagementPermission ? 'Vehicles' : 'Devices'} could be found.`;
            } else if (baseResults.length === 3) {
                baseResults[0].name = `No matching ${this.hasDAManagement ? 'Associates or ' : ''}${this.hasVehicleManagementPermission ? 'Vehicles or ' : ''}Devices could be found.`;
            }
        return baseResults;
    },
    },
    mounted(){
        this.placeholder = 'Type to search Associates, Vehicles, and Devices...'

        // set placeholder and searchable types based on permissions.
        // this component won't load if they don't have any of the three permissions
        if(!this.hasDAManagement ){ 
            this.searchTypes = this.searchTypes.filter(t=>t!='Staff')
        }
        if(!this.hasVehicleManagementPermission ){ 
            this.searchTypes = this.searchTypes.filter(t=>t!='Vehicle')
        }

        // Update placeholder based on available search types
        if(this.searchTypes.length === 3) {
            this.placeholder = 'Type to search Associates, Vehicles, and Devices...'
        } else if(this.searchTypes.length === 2) {
            if(this.searchTypes.includes('Staff') && this.searchTypes.includes('Vehicle')) {
                this.placeholder = 'Type to search Associates and Vehicles...'
            } else if(this.searchTypes.includes('Staff') && this.searchTypes.includes('Device')) {
                this.placeholder = 'Type to search Associates and Devices...'
            } else if(this.searchTypes.includes('Vehicle') && this.searchTypes.includes('Device')) {
                this.placeholder = 'Type to search Vehicles and Devices...'
            }
        } else if(this.searchTypes.length === 1) {
            if(this.searchTypes.includes('Staff')) {
                this.placeholder = 'Type to search Associates...'
            } else if(this.searchTypes.includes('Vehicle')) {
                this.placeholder = 'Type to search Vehicles...'
            } else if(this.searchTypes.includes('Device')) {
                this.placeholder = 'Type to search Devices...'
            }
        }
        let input = this.$refs['search-input']        
        input.$refs.input.$el.addEventListener('keyup', this.onEnterKey, false)
    },

    methods:{

        onEnterKey(e) {
            e.preventDefault()
            if(e.key === 'Enter'){
                this.close(this.search, true)
            }
        },
        close(e, searchfromEnter){
            
            this.search = ''
            //if(this.isMobile){
            if(searchfromEnter){
                this.$router.push(`/search?q=${e}`).catch(e => {})
            }
            this.$refs['search-input'].close()
            this.$refs['search-input'].$refs['input'].blur()
            //}
        },

        focus() {
            // clear previous results
            this.search = ''
            this.$refs['search-input'].suggestions = []
        },

        renderFields(fields) {  
          if(!fields) return 
            const fieldLabels = fields.split(',').filter(f => !!f && f.toLowerCase() !== 'name').map(field => this.fieldMap[field]).filter(label => !!label)
            return [...new Set(fieldLabels)]
        },
        
        async loadData(search, cb, e) {
            let results = []
            //if(this.search.length < 3) return cb([])
            const wordCount = this.search.trim().split(/\s+/).filter(word => word).length;

            if (wordCount > 5) {
                document.body.classList.add('no-results');
                return cb([{ 
                    name: 'Please use no more than 5 words in your search.', 
                    link: 'too-many-words'
                }]);
            }
            let body = { 
                group: this.user.tenant.group, 
                types:this.searchTypes,
                search: this.search.replace(/\s+/g, ' '),
                matchingFields: true,
                sortField: 'rank',
                sortDirection: 'asc',
                limit: 5,
                offset: 0
            }
            try {
                
                results = await API.post('rds', '/query/Search', { body })
                this.totalResults = results.total
                if(results?.data?.length){
                    results = results.data.map(r => {
                        let deviceLink = '/devices';
                        if (r.type == 'Device') {
                            const permissionWirelessSupportSync = this.tenantFeaturePermissions["permissionWirelessSupportSync"];
                            const hasCompanyDevicesPermission = this.hasCompanyDevicesPermission;
                            if (permissionWirelessSupportSync === true && hasCompanyDevicesPermission) {
                                deviceLink = this.goToAthena(`/device/detail/${r.id}`);
                            }
                        }
                        return {
                            type: r.type,
                            isVehicle: r.type == 'Vehicle',
                            isDevice: r.type == 'Device',
                            name: r.name,
                            record: r, 
                            status: r.status,
                            fields: this.renderFields(r.fields),
                            link: r.type == 'Associate' ? `/da-management/${r.id}` : 
                                  r.type == 'Vehicle' ? `/vehicles/${r.id}` : 
                                  r.type == 'Device' ? deviceLink : '#'
                        }
                    })
                   
                    if(this.totalResults > 5){
                        results.push({ name: 'view all', link: `/search?q=${this.search}`})
                    }
                    document.body.classList.remove('no-results')
                    
                } else {
                    results = this.noResults
                    this.totalResults = 0
                    document.body.classList.add('no-results')
                }

                return cb(results)
                
            } catch (e) {
                results = this.noResults
                this.totalResults = 0
            } 
            return cb(results)
        },

        async handleClick(data,e) {
            if(data.link=='no-results'){ 
                return false
            }
            if (typeof data.link === 'string' && (data.link.startsWith('http://') || data.link.startsWith('https://'))) {
                window.location.href = data.link;
            } else {
                this.$router.push(data.link).catch(e => {})
            }
            setTimeout(()=>this.search='',200)
        },

        setClassStatus(status) {
            if (!status) return ''
            
            const statusLower = status.toLowerCase()
            if (statusLower === 'active') {
                return 'bg-green-pill'
            } else if (statusLower.includes('inactive')) {
                return 'bg-red-pill'
            } else if (statusLower === 'onboarding') {
                return 'bg-purple-pill'
            } else {
                return 'bg-gray-pill'
            }
        }
    }

}
</script>
<style>
.results-wrap .el-autocomplete-suggestion .el-scrollbar__thumb,
.results-wrap-mobile .el-autocomplete-suggestion .el-scrollbar__thumb{ 
    display: none;
}
.results-wrap .el-scrollbar .el-autocomplete-suggestion__list li:nth-child(6),
.results-wrap-mobile .el-scrollbar .el-autocomplete-suggestion__list li:nth-child(6){
    border-top: 1px solid #ccc;
}
.results-wrap .el-scrollbar__wrap--hidden-default,
.results-wrap-mobile .el-scrollbar__wrap--hidden-default {
    scrollbar-width: none;
    min-height: 320px;
}
.results-wrap .el-scrollbar .el-scrollbar__wrap,
.results-wrap-mobile .el-scrollbar .el-scrollbar__wrap{
    min-height: 320px;
    display: contents;
}

#mobile-search {
    opacity: 0.0;
    transform: translateY(-30px);
    box-shadow: rgba(0,0,0,.04) 6px 6px 6px;
    border-bottom: 1px solid #eee;
}
#mobile-search.active {
    transform: translateY(0);
    opacity: 1.0 !important;
}

#mobile-search input.el-input__inner {
    border: 0;
    background: transparent;
}
.el-autocomplete-suggestion.el-popper.results-wrap-mobile {
    left: 7% !important;
    width: 86% !important;
}
.el-autocomplete-suggestion.el-popper.results-wrap-mobile .popper__arrow{
    left: 50% !important;
}
@media only screen and (max-width: 768px) {
    .el-autocomplete-suggestion.el-popper.results-wrap {
        left: 7% !important;
        width: 86% !important;
    }
    .el-autocomplete-suggestion.el-popper.results-wrap .popper__arrow{
        left: 50% !important;
    }
}
.search .el-input__suffix .el-icon-close{
    font-size: 22px;
    margin-top: 7px;
    border-radius: 15px;
    padding: 2px;
}
.el-autocomplete-suggestion .matching-fields {
    line-height: 20px;
}
.no-results .el-autocomplete-suggestion li:first-child {
    pointer-events: none;
}
/* iOS double tap issue */
.results-wrap-mobile .el-scrollbar__bar {
    opacity: 1!important;
}
</style>
